  <!-- MODAL -->
  <ng-template #contenidosedes let-modal>
    <h4 class="modal-title w-100 text-center"> Configuraci&oacute;n Predeterminada de Inicio Sesi&oacute;n</h4>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
    </div>
    <div class="modal-body">

      <ng-container *ngFor="let form_elem of MenuCopania;let indice = index">
        <div class="col-md-10">
          <div class="mb-2 row">
            <label class="col-md-2 col-form-label"> Compa&ntilde;ia</label>
            <div class="col-sm-8">
              <select class="form-control" id="compania" [(ngModel)]='this.CNT05COD'>
                <option *ngFor="let opt of form_elem.COMPANIAS" [value]="opt.CNT05COD" >
                  {{opt.CNT05DES}}
                </option>
               
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-10">
          <div class="mb-2 row">
            <label class="col-md-2 col-form-label"> Sedes</label>
            <div class="col-sm-8">
              <select class="form-control" id="sede" [(ngModel)]='this.M05COD'>
                <option *ngFor="let opt2 of form_elem.SEDES" [value]="opt2.M05COD" >
                  {{opt2.M05DES}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-10">
          <div class="mb-2 row">
            <label class="col-md-2 col-form-label"> Mostrar Filtros</label>
            <div class="col-sm-8">
              <select class="form-control" id="filtros" [(ngModel)]='this.MostrarFiltroPrincipal'>
                <option [value]="'true'">Si</option>
                <option [value]="'false'">No</option>
              </select>
            </div>
          </div>
        </div>
      </ng-container>
      
      <div class="col-md-10">
        <div class="mb-2 row">
          <label class="col-md-2 col-form-label"> Modulo Default</label>
          <div class="col-sm-8">
            <select class="form-control" id="moddefault" [(ngModel)]='this.ModuloDefault'>
              <option *ngFor="let modulo of MenuModulo" [value]="modulo.S02COD" >
                {{modulo.S02DES}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <div >
        <button  type='button' class="btn btn-success btn-label waves-light" (click)="guardar($event)">
          <i class="mdi mdi-content-save-all  label-icon"></i>
          Guardar
        </button>
      </div>

      <button _ngcontent-rmn-c243="" type="button" style="margin-left: 10px" (click)="modal.dismiss()"
        class="btn btn-info btn-label waves-light"><i _ngcontent-rmn-c243="" class="fas fa-sign-out-alt label-icon"></i>
        Salir</button>
    </div>
  </ng-template>
  <!-- END MODAL -->